import {
  HK_PACK_SHIP_BACK,
  HK_PACK_SHIP_NEXT,
} from '../../common/constants/HotKeys.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import {navigate} from '../../common/location.js'
import {useSelector} from '../../store.js'
import {
  packShipOrderNumbersSelector,
  indexSelector,
  backParamsSelector,
  nextParamsSelector,
  verifiedOrderCountSelector,
  PACK_SHIP_URI_COMPONENT,
} from './packShipFunctions.js'

export default function NextBackCounter() {
  const orderNumbers = useSelector(packShipOrderNumbersSelector)
  const index = useSelector(indexSelector)
  const backParams = useSelector(backParamsSelector)
  const nextParams = useSelector(nextParamsSelector)
  const verifiedOrderCount = useSelector(verifiedOrderCountSelector)

  if (orderNumbers.length < 2) {
    return null
  }

  return (
    <div className="wrap--row margin-top-10">
      <div className="medium-6 medium-centered columns align-center">
        <ul className="list list--no-style">
          <li className="list__item--inline-block fs-01 v-align-top margin-right-20 margin-bottom-0">
            <ButtonPrimary
              isOutlined
              className="btn--x-sm"
              isDisabled={!backParams}
              onClick={() => navigate([PACK_SHIP_URI_COMPONENT], backParams)}
              hotKey={HK_PACK_SHIP_BACK}
            >
              ◀
            </ButtonPrimary>
          </li>
          <li className="list__item--inline-block fs-01 v-align-top margin-right-20 margin-bottom-0">
            <div className="lh-sm">
              <strong>
                {index + 1} of {orderNumbers.length} Orders
              </strong>
            </div>
            <div className="fs-00">({verifiedOrderCount} verified)</div>
          </li>
          <li className="list__item--inline-block v-align-top fs-01 margin-bottom-0">
            <ButtonPrimary
              isOutlined
              className="btn--x-sm"
              isDisabled={!nextParams}
              onClick={() => navigate([PACK_SHIP_URI_COMPONENT], nextParams)}
              hotKey={HK_PACK_SHIP_NEXT}
            >
              ▶
            </ButtonPrimary>
          </li>
        </ul>
      </div>
    </div>
  )
}
